export default "__VITE_ASSET__DaxJtZl4__"